<template>
  <div class="x-skill-bar" :class="{'red': red}" data-x-element="skill_bar" :data-x-params="'{percent:\''+progress+'%\''+'}'">
    <div class="bar" :style="'width: '+progress+'%;'">
      <div class="percent">{{progress}}%</div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'skillbar',
  props: ['progress', 'red']
}
</script>

<style lang="scss">
.red{
    background-color: #f77a7a;
}
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}*/
</style>



// WEBPACK FOOTER //
// skillbar.vue?7816d52b